import { StyleSheet } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  container: {
    flex: 1,
    width: "100%",
    margin: "auto",
  },
  title: {
    marginTop: CustomPlatform.select({
      tv: 0,
      default: spacing(8),
    }),
    marginBottom: CustomPlatform.select({
      tv: spacing(6),
      default: spacing(8),
    }),
  },
}));

export default stylesheet;
